// extracted by mini-css-extract-plugin
export default {"root":"v8JR6b","initialized":"OrWVLX","testNodeWrapper":"j1tpvT","testText":"oBeJjb"};